import React , {useState , useEffect} from 'react';
import { fetchTotalSoldCars } from '../../stores/api_calls/dashboard';
import {FaTags} from 'react-icons/fa'
import {AiOutlineArrowRight} from 'react-icons/ai'
import './card.scss'
import { useNavigate } from 'react-router-dom';

const SoldCars = () => {

    const navigate = useNavigate()
    const [soldCars , setSoldCars] = useState()
    const [isLoading , setIsLoading] = useState(false)

    useEffect(()=>{
        setIsLoading(true)
        const getSoldCars = fetchTotalSoldCars()

        getSoldCars.then((res)=>{
            if(res.data){
                if(res.data.success){
                    setSoldCars(res.data.data)
                    setIsLoading(false)
                }
            }
        }).catch((e)=>{
            console.log(e)
        })
    },[])

    return (
        <div>
            <div className='sold header-card'>
                <p className='header-text'>Sold <br/> Bikes</p>
                <FaTags/>
            </div>
            <div className='sold body-card'>
                <p className='sold-text'>Total : {isLoading ? 'fetching' : !isLoading&&soldCars? soldCars.total_sold_products : 0}</p>
                <div className='goIcon' onClick={()=>navigate("../bikes/sold", { replace: true })}>
                    <AiOutlineArrowRight/>
                </div>
            </div>
        </div>
    )
}

export default SoldCars
